import { SxProps, Theme } from '@mui/material';

export const styles: Record<'avatar' | 'contact' | 'email' | 'widget', SxProps<Theme>> = {
  avatar: {
    borderRadius: '10px',
    height: '66px',
  },
  contact: {
    justifyContent: 'space-between',
  },
  email: {
    textDecoration: 'none',
  },
  widget: {
    backgroundColor: (theme) => theme.palette.gray[50],
    borderRadius: '10px',
    padding: (theme) => theme.spacing(3, 4),
  },
};
